import { css } from '@emotion/css';
import { colors } from '@editor2/styles/colors';

export const generateQuestionsModalStyles = css`
	.countBlock {
		display: flex;
		align-items: center;
		justify-content: space-between;

		label {
			margin-bottom: 0;
		}

		input {
			width: 60px;
		}
	}

	.infoMesage {
		font-size: 14px;
		color: ${colors.infoText};
	}
`;
